export const RPMVideo = (function () {
	'use strict';

	let findAllFrames;

	function init() {
		const tapAction = window.ontouchstart === null ? 'touchstart' : 'click';
		findAllFrames = document.querySelectorAll('.rpmblock--video__video-iframe');
		if (findAllFrames.length > 0) {
			findAllFrames.forEach((frame) => {
				let frameButton = frame.querySelector('.rpmblock--video__video-button');
				let frameVideo = frame.querySelector('.rpmblock--video__video-content iframe');
				let player;

				frameButton.addEventListener(tapAction, () => {
					frameButton.classList.add('--hide');

					if (!player) {
						player = new YT.Player(frameVideo, {
							events: {
								onReady: onPlayerReady,
							},
						});
					} else {
						player.playVideo();
					}
				});
			});
		}
	}

	function onPlayerReady(event) {
		event.target.playVideo();
	}

	return {
		init: init,
	};
})();
